var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 65,
    viewBox: "0 0 88 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_119_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4258 19.1729C77.4297 16.7843 82 10.9951 82 7.74334C82 3.79954 78.6406 0.599854 74.5 0.599854C70.3594 0.599854 67 3.79954 67 7.74334C67 10.9951 71.5703 16.7843 73.5742 19.1729C74.0547 19.7422 74.9453 19.7422 75.4258 19.1729ZM74.5 5.36218C75.163 5.36218 75.7989 5.61305 76.2678 6.0596C76.7366 6.50616 77 7.11182 77 7.74334C77 8.37486 76.7366 8.98052 76.2678 9.42708C75.7989 9.87363 75.163 10.1245 74.5 10.1245C73.837 10.1245 73.2011 9.87363 72.7322 9.42708C72.2634 8.98052 72 8.37486 72 7.74334C72 7.11182 72.2634 6.50616 72.7322 6.0596C73.2011 5.61305 73.837 5.36218 74.5 5.36218Z",
    fill: "#615C9F",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.975 58.6336C23.25 53.2278 33 40.126 33 32.7667C33 23.8412 25.8333 16.5999 17 16.5999C8.16667 16.5999 1 23.8412 1 32.7667C1 40.126 10.75 53.2278 15.025 58.6336C16.05 59.9219 17.95 59.9219 18.975 58.6336ZM17 27.3777C18.4145 27.3777 19.771 27.9455 20.7712 28.9561C21.7714 29.9668 22.3333 31.3375 22.3333 32.7667C22.3333 34.1959 21.7714 35.5666 20.7712 36.5773C19.771 37.5879 18.4145 38.1556 17 38.1556C15.5855 38.1556 14.229 37.5879 13.2288 36.5773C12.2286 35.5666 11.6667 34.1959 11.6667 32.7667C11.6667 31.3375 12.2286 29.9668 13.2288 28.9561C14.229 27.9455 15.5855 27.3777 17 27.3777Z",
    fill: "#615C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.537 60.1157L29.1281 62.482L22.8174 61.5368L23.3023 59.0193L29.537 60.1157Z",
    fill: "#615C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4077 61.0642L37.011 63.2569L30.7624 62.6997L31.1144 60.5356L31.3484 60.3176L37.4077 61.0642Z",
    fill: "#615C9F",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0062 63.6928L38.77 63.526L38.9428 61.1349L45.1374 61.4122C45.3121 61.5125 45.1908 63.5835 45.0047 63.6921L45.0062 63.6928Z",
    fill: "#615C9F",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7815 63.6248L46.9858 61.3473L53.0516 60.9727L53.2328 62.9933C51.0968 63.3589 48.9387 63.6683 46.7823 63.6269L46.7815 63.6248Z",
    fill: "#615C9F",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.23 57.4829C59.6239 60.0332 57.5172 61.8574 55.0953 62.3854L54.4652 60.546C56.2057 59.9417 57.9736 59.039 58.2428 56.9184L60.23 57.4829Z",
    fill: "#615C9F",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2939 55.4969L58.4062 55.4516C58.4192 53.4599 57.7877 51.6235 57.1513 49.8086C57.1492 49.3443 58.5177 48.8053 58.7499 48.9418C59.4108 49.4936 60.7546 55.2352 60.2939 55.4969Z",
    fill: "#615C9F",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0416 46.9584C58.0626 47.3198 56.5601 48.1145 56.3292 47.9458L53.5844 42.5283L54.7297 41.5458L55.1239 41.7985L58.0423 46.9569L58.0416 46.9584Z",
    fill: "#615C9F",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0844 39.9499L52.6106 41.0676L49.266 35.8392L49.3619 35.6608C49.6095 35.5133 50.4037 34.6774 50.6304 34.8698L54.0844 39.9499Z",
    fill: "#615C9F",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4543 27.9545L49.6766 33.2995L48.4285 34.2795L45.176 28.8142L46.4543 27.9545Z",
    fill: "#615C9F",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7053 21.2072C44.3041 22.8864 44.9654 24.7074 45.6901 26.4228L44.4093 27.1512C43.2926 24.9717 42.7354 22.1685 44.8078 20.2147L45.7053 21.2072Z",
    fill: "#615C9F",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8805 19.2258C50.881 19.2819 48.8806 19.7093 47.006 20.507L46.4706 19.2559C48.5275 18.291 50.7545 18.0158 52.9499 17.8117L52.8805 19.2258Z",
    fill: "#615C9F",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.011 18.1283L60.8927 19.0708L54.5139 19.0935L54.6472 17.6947C55.4913 17.8857 60.7457 17.6193 61.0103 18.1298L61.011 18.1283Z",
    fill: "#615C9F",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9746 20.0176L62.4606 19.151L62.8031 18.0445C63.8627 18.4667 67.8288 18.3025 68.5005 18.9125C68.6477 19.0457 68.9341 19.7606 68.9746 20.0176Z",
    fill: "#615C9F",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 64,
    fill: "white",
    transform: "translate(0 0.599976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceIcon);
export default __webpack_public_path__ + "static/media/Distance_icon.86642f21f534129549df8ecf485639fa.svg";
export { ForwardRef as ReactComponent };